export enum ELogisticApiUrl {
  LOGISTIC = '/api/logistics/requests',
  VEHICLE_TYPES = '/api/logistics/vehicleTypes',
  CREATIONS = '/api/logistic/creations',
}
